import React from "react";
import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TravelChatAssistant from "./components/TravelChatAssistant";
import HomePage from "./pages/HomePage";
import DestinationsPage from "./pages/DestinationsPage";
import VisaPage from "./pages/VisaPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import TripBuilderPage from "./pages/TripBuilderPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import TermsPage from "./pages/TermsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminHomepageImages from "./pages/AdminHomepageImages";
import AdminDestinations from "./pages/AdminDestinations";
import AdminItineraries from "./pages/AdminItineraries";
import AdminInquiries from "./pages/AdminInquiries";
import AdminTestimonials from "./pages/AdminTestimonials";
import AdminAbout from "./pages/AdminAbout";
import AdminBlog from "./pages/AdminBlog";
import AdminGallery from "./pages/AdminGallery";
import AdminServices from "./pages/AdminServices";
import AdminSettings from "./pages/AdminSettings";
import AdminUsers from "./pages/AdminUsers";
import AdminSavedItineraries from "./pages/AdminSavedItineraries";
import AdminVisas from "./pages/AdminVisas";
import AdminVisaInquiries from "./pages/AdminVisaInquiries";
import AdminDiscountCodes from "./pages/AdminDiscountCodes";
import AdminInstantItineraries from "./pages/AdminInstantItineraries";
import AdminPricing from "./pages/AdminPricing";
import AdminTravelQuotes from "./pages/AdminTravelQuotes";
import AdminVouchers from "./pages/AdminVouchers";
import AdminChatAnalytics from "./pages/AdminChatAnalytics";
import AdminLiveChat from "./pages/AdminLiveChat";
import AdminChatLeads from "./pages/AdminChatLeads";
import AdminReports from "./pages/AdminReports";
import CustomerAuthPage from "./pages/CustomerAuthPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import InstantItineraryPage from "./pages/InstantItineraryPage";
import BookRequestPage from "./pages/BookRequestPage";
import MyAccountPage from "./pages/MyAccountPage";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CustomerAuthProvider>
        <Routes>
          {/* Admin Routes - No Header/Footer */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboard />}>
            <Route path="dashboard" element={null} />
            <Route path="homepage-images" element={<AdminHomepageImages />} />
            <Route path="destinations" element={<AdminDestinations />} />
            <Route path="itineraries" element={<AdminItineraries />} />
            <Route path="saved-itineraries" element={<AdminSavedItineraries />} />
            <Route path="visas" element={<AdminVisas />} />
            <Route path="visa-inquiries" element={<AdminVisaInquiries />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="about" element={<AdminAbout />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="discount-codes" element={<AdminDiscountCodes />} />
            <Route path="pricing" element={<AdminPricing />} />
            <Route path="instant-itineraries" element={<AdminInstantItineraries />} />
            <Route path="travel-quotes" element={<AdminTravelQuotes />} />
            <Route path="vouchers" element={<AdminVouchers />} />
            <Route path="chat-analytics" element={<AdminChatAnalytics />} />
            <Route path="live-chat" element={<AdminLiveChat />} />
            <Route path="chat-leads" element={<AdminChatLeads />} />
            <Route path="reports" element={<AdminReports />} />
          </Route>

          {/* Public Routes - With Header/Footer */}
          <Route
            path="*"
            element={
              <>
                <Header />
                <div className="pt-28">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/destinations" element={<DestinationsPage />} />
                    <Route path="/visa" element={<VisaPage />} />
                    <Route path="/instant-itinerary" element={<InstantItineraryPage />} />
                    <Route path="/book-request" element={<BookRequestPage />} />
                    <Route path="/destination/:destinationId/activities" element={<ActivitiesPage />} />
                    <Route path="/destination/:destinationId/trip-builder" element={<TripBuilderPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/login" element={<CustomerAuthPage />} />
                    <Route path="/register" element={<CustomerAuthPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/my-account" element={<MyAccountPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </div>
                <Footer />
                <TravelChatAssistant />
              </>
            }
          />
        </Routes>
        </CustomerAuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
